/* eslint-disable react/prop-types */
/* eslint-disable no-redeclare */
export const styles = {
    invoiceHeading: {
        fontFamily: 'Inter, sans-serif'
    },
    centerText: {
        fontFamily: 'Inter, sans-serif',
        textAlign: 'center'
    },
    robotoText: {
        fontFamily: 'Roboto, sans-serif'
    },
    robotoCenter: {
        fontFamily: 'Roboto, sans-serif',
        textAlign: 'center'
    }
};